import React from "react";
import PropTypes from "prop-types";

import { Text } from "atoms";

export const Label = ({
  text,
  fontSize,
  color,
  fontFamily,
  astrixColor,
  req,
  ...props
}) => {
  return (
    <Text fontSize={fontSize} color={color} fontFamily={fontFamily} {...props}>
      {text}
      {req && (
        <Text as="span" color={astrixColor || "accents.100"}>
          *
        </Text>
      )}
    </Text>
  );
};

Text.defaultProps = {
  fontSize: "1.6rem",
  fontFamily: "NeometricBold",
  color: "primary.900",
  astrixColor: "accents.100",
};

Text.propTypes = {
  color: PropTypes.string,
  astrixColor: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
